/** 每日登录免费领取积分（接口未返回时的展示默认值） */
export const DEFAULT_DAILY_BONUS_AMOUNT = 70;
